module.exports = __webpack_public_path__ + "static/scale-model-of-san-antonio-botanical-garden-in-san-antonio-texas-b5f5fbc77a42c50a237dd8731a5c691b.png";